import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import action from '../../../../actions/index';
import RoomTypes from './RoomTypes';
import * as hotelActions from './../../../../actions/hotelAction';

const mapStateToProps = state => {
    return {
        roomTypeState: state.roomTypeReducer,
        hotelState: state.hotelReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListRoomTypes: (filters) => {
            dispatch(action.getListRoomTypes(filters))
        },
        getHotelDetail: (id) => dispatch(hotelActions.getHotelDetail(id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RoomTypes));
